import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Engagement: Represents a relationship between an employee and a project, which a description of their role on that project and the time and hours billed towards that project. Also represents an employees availability.',
    name: 'Engagements',
    partialId: PartialId.Standard.create('engagements'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
